module.exports = __webpack_public_path__ + "img/capacitor-teal.3c2bccf1.webp";